import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { DatePipe } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { JsonpModule } from '@angular/http';

import { MaterialModule } from '@angular/material';

import { AppComponent } from './app.component';
//import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ModalModule }              from 'ngx-bootstrap';
import { AccordionModule, SharedModule, SliderModule } from 'primeng/primeng';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';


// Routing Module
import { AppRoutingModule } from './app.routing';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { HeaderDefaultComponent } from './layouts/header-default.component';
import { HeaderGameComponent } from './layouts/header-game.component';
import { HeaderBondMathComponent } from './layouts/header-bondmath.component';
import { HeaderHorizonCalcComponent } from './layouts/header-horizoncalc.component';
import { LastYearComponent } from './game/last-year.component';
import { TimerComponent } from './game/timer.component';
import { CountdownComponent } from './game/countdown.component';
import { LastYieldDirective } from './game/last-yield.directive';
import { GameComponentService } from './game/gameComponent.service';
import { ConfirmService } from './game/confirm.service';
import { BondMathComponentService } from './bondmath/bondmathComponent.service';
import { HorizonCalcComponentService } from './horizoncalc/horizoncalcComponent.service';
import { ActivateGuard, DeactivateGuard } from './game/deactivate-guard';


//import { ToggleFullscreenDirective } from './game/fullscreen.directive';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    SliderModule,
    FormsModule,
    MaterialModule.forRoot(),
    ModalModule.forRoot(),
    AccordionModule,
    HttpModule,
    JsonpModule,
    SharedModule
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    HeaderDefaultComponent,
    HeaderGameComponent,
    HeaderBondMathComponent,
    HeaderHorizonCalcComponent,
    LastYearComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    LastYieldDirective,
    TimerComponent,
    CountdownComponent
  ],
  // providers: [{   //comment out whole section when trying to get routing w/o #
  //   provide: LocationStrategy,
  //   useClass: HashLocationStrategy
  // }],
  providers: [
    ActivateGuard, DeactivateGuard,
    DatePipe
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts